// src/private/isPromise.ts
function isPromise(value) {
  return !!((typeof value === "function" || typeof value === "object") && value && "then" in value && typeof value.then === "function");
}

export {
  isPromise
};
//# sourceMappingURL=chunk-MBTBSBLB.mjs.map